export default "__VITE_ASSET__BVhIqo5q__"